import * as React from 'react';

function BookStackIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="100%" height="100%" viewBox="0 0 25 25" fill="none" {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.667 3.333h15c.92 0 1.666.746 1.666 1.667V6.667c0 .92-.746 1.666-1.666 1.666h-15C5.747 8.333 5 7.587 5 6.667V5c0-.92.746-1.667 1.667-1.667zm-2.888 5a3.318 3.318 0 01-.446-1.666V5a3.333 3.333 0 013.334-3.333h15A3.333 3.333 0 0125 5V6.667A3.333 3.333 0 0121.667 10h-.446c.283.49.446 1.06.446 1.667v1.666c0 .607-.163 1.177-.446 1.667h.446A3.333 3.333 0 0125 18.333V20a3.333 3.333 0 01-3.333 3.333h-15A3.333 3.333 0 013.333 20V18.333c0-.607.163-1.176.446-1.666h-.446A3.333 3.333 0 010 13.333v-1.666a3.333 3.333 0 013.333-3.334h.446zM18.333 10h-15c-.92 0-1.666.746-1.666 1.667v1.666c0 .92.746 1.667 1.666 1.667h15c.92 0 1.667-.746 1.667-1.667v-1.666c0-.92-.746-1.667-1.667-1.667zM5 18.333c0-.92.746-1.666 1.667-1.666h15c.92 0 1.666.746 1.666 1.666V20c0 .92-.746 1.667-1.666 1.667h-15C5.747 21.667 5 20.92 5 20V18.333z"
				fill="currentColor"
			/>
		</svg>
	);
}

const MemoBookStackIcon = React.memo(BookStackIcon);
export default MemoBookStackIcon;
